module.exports = __webpack_public_path__ + "static/media/logo_icon.77e6b269.svg";